/**
 * Main scripts, loaded on all pages.
 *
 * @package third-party-cookie-features
 */

/**
 * Internal dependencies
 */
import '../scss/main.scss';

window.$ = window.$ || jQuery;

import GlobalCookie from './global-cookie';
import NADA from './nada';
import RETAIL360 from './retail360';

window.GLBLCOKIE = GlobalCookie;
window.GLBLCOKIE.nada = NADA;
window.GLBLCOKIE.retail360 = RETAIL360;

GlobalCookie.init();
